'use strict';
import React, { PureComponent } from 'react';
import SeccionCriteriosContables from './SeccionCriteriosContables/SeccionCriteriosContables';


class DatosMovimiento extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarOpcionCombo = this.cambiarOpcionCombo.bind(this);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    cambiarOpcionCombo(nombreCombo, valorCombo){
        this.props.cambiarOpcionCombo(nombreCombo, valorCombo)
    }

    render() {

        const {
            cambiarOpcionComboCriterios,
            checkAperturaPorSocio,
            combosABMModelos,
            comboCampoImporte,
            comboCampoImporteSeleccionado,
            comboTipoMovimientoSeleccionado,
            contenedorCombosCriteriosContables,
            errorValidacion,
            elegirOpcionSelector,
            mostrarSpinnerModalRenglones,
            rbModalAltaEdicionRenglonContable,
            seleccionarRadioButtonABMModelos,
            setMostrarLinkVerMas,
            comboTiposMovimientos
        } = this.props;

        let arrayOpcionesTiposMovimiento = [];
        let arrayOpcionesImporte = [];
        let arrayCombosCriteriosContables =[];
        let arraySelectoresCriteriosContables = [];
        let opciones = [];
        let seleccione = [<option key={0} value={0}>{"Seleccione..."}</option>];
        let opcionesSelectores = [<option key={999} value={999}>{"Todos"}</option>]
        let opcionesSeleccionadas = [];
        let rbTipoRenglon = rbModalAltaEdicionRenglonContable.rbTipoRenglon;
        
        contenedorCombosCriteriosContables.length > 0 && contenedorCombosCriteriosContables.forEach(element => {
            element.valoresCriterios.map(e => {
                if(!element.esSeleccionMultiple){
                    opciones.push(
                        <option 
                        key={e.Id + e.Descripcion} value={e.Id}
                        >{e.Descripcion}</option>
                    )
                }
                else if(!e.estaSeleccionado && element.esSeleccionMultiple){
                    opciones.push(
                        <option 
                        key={e.Id + e.Descripcion} value={e.Id}
                        >{e.Descripcion}</option>
                    )
                }else{
                    opcionesSeleccionadas.push(
                        {
                            id:e.Id,
                            codigo:e.Codigo,
                            descripcion:e.Descripcion
                        }
                    )
                }
            })

            element.esSeleccionMultiple ?
                arraySelectoresCriteriosContables.push(
                        {
                            descripcion:element.descripcion,
                            nombreCombo: element.nombreCombo,
                            valoresCriterios: opciones.concat( opciones.length == 0 & opcionesSeleccionadas.length == 0 ? [] : opcionesSelectores),
                            valoresSeleccionados:opcionesSeleccionadas,
                            mostrarLinkVerMas:element.mostrarLinkVerMas,
                            valorSeleccionadoCombo:element.valorSeleccionadoCombo
                        }
                    )
                :
                arrayCombosCriteriosContables.push(
                    {
                        descripcion:element.descripcion,
                        nombreCombo: element.nombreCombo,
                        valoresCriterios: seleccione.concat(opciones),
                        valorSeleccionado:combosABMModelos[element.nombreCombo] ? combosABMModelos[element.nombreCombo] :element.valorSeleccionado
                    }
                );
            opciones = [];
            opcionesSeleccionadas = [];
        });

        comboTiposMovimientos.map(tipoMovimiento => {
            arrayOpcionesTiposMovimiento.push(
                checkAperturaPorSocio && !tipoMovimiento.PermiteAbreSocio ?               
                <option 
                key={tipoMovimiento.Id + tipoMovimiento.Descripcion} value={tipoMovimiento.Id}
                data-toggle="tooltip" data-title="El Tipo de movimiento elegido no permite una apertura por socio" data-placement="top" data-original-title=""
                >{tipoMovimiento.Descripcion}</option>
                :
                <option 
                key={tipoMovimiento.Id + tipoMovimiento.Descripcion} value={tipoMovimiento.Id}
                >{tipoMovimiento.Descripcion}</option>
            );
        });

        comboCampoImporte && comboCampoImporte.map(campoImporte => {
            arrayOpcionesImporte.push(
                <option 
                key={campoImporte.Id + campoImporte.Descripcion} value={campoImporte.Id}
                >{campoImporte.Descripcion}</option>
            );
        });


        return (
            <div>
                {rbTipoRenglon == 1 &&
                    <div>
                        <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoria"></div>

                        <div className="ABMModelosModalContainer__subtitulo ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorSubtitulo">
                            Datos del movimiento
                        </div>

                        <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCuentaContable">
                            <div className="seccionDatosGenerales__tituloSecundario">Tipo de movimiento</div>
                            
                            <div>
                                <select 
                                    className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect ABMModelos__seccionDatosGenerales__sucursalSelect"
                                    name="comboTipoMovimientoSeleccionado"
                                    onChange={(event) => {
                                        const indice = event.target.selectedIndex;
                                        const opcion = event.target.options[indice].value;
                                        this.cambiarOpcionCombo("comboTipoMovimientoSeleccionado", opcion)
                                    }}
                                    value={comboTipoMovimientoSeleccionado}>
                                    {arrayOpcionesTiposMovimiento}
                                </select>
                            </div>
                        </div>

                        <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorCuentaContable">
                            <div className="seccionDatosGenerales__tituloSecundario">Campo de importe</div>

                            <div>
                                <select 
                                    className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect ABMModelos__seccionDatosGenerales__sucursalSelect"
                                    name="comboCampoImporteSeleccionado"
                                    onChange={(event) => {
                                        const indice = event.target.selectedIndex;
                                        const opcion = event.target.options[indice].value;
                                        this.cambiarOpcionCombo("comboCampoImporteSeleccionado", opcion)
                                    }}
                                    value={comboCampoImporteSeleccionado}>
                                    {arrayOpcionesImporte}
                                </select>
                            </div>
                        </div>
                    
                        <SeccionCriteriosContables 
                            cambiarOpcionComboCriterios={cambiarOpcionComboCriterios}
                            elegirOpcionSelector={elegirOpcionSelector}
                            seleccionarRadioButtonABMModelos={seleccionarRadioButtonABMModelos}
                            setMostrarLinkVerMas={setMostrarLinkVerMas}

                            arrayCombosCriteriosContables={arrayCombosCriteriosContables}
                            arraySelectoresCriteriosContables={arraySelectoresCriteriosContables}
                            errorValidacion={errorValidacion}
                            mostrarSpinnerModalRenglones={mostrarSpinnerModalRenglones}
                            rbModalAltaEdicionRenglonContable={rbModalAltaEdicionRenglonContable}
                        />
                    </div>
                }
            </div>
        );
    }
}

export default DatosMovimiento;